(() => {
  const drawer = document.querySelector('header-drawer');
  const tpl = document.getElementById('MenuDrawerNavTemplate');
  if (!drawer || !tpl) return;

  let hydrated = false;

  const hydrate = () => {
    if (hydrated) return;
    hydrated = true;

    const frag = tpl.content.cloneNode(true);
    const summaries = frag.querySelectorAll('summary:not(.no-control-menu)');
    const buttons = frag.querySelectorAll('button:not(.no-control-menu)');

    // Bind only the new elements; the opener is already bound by global.js
    summaries.forEach((s) =>
      s.addEventListener('click', drawer.onSummaryClick.bind(drawer))
    );
    buttons.forEach((b) =>
      b.addEventListener('click', drawer.onCloseButtonClick.bind(drawer))
    );

    tpl.replaceWith(frag);
  };

  // Warm up on intent, so the menu is ready before the click lands
  ['pointerenter', 'touchstart', 'focusin'].forEach((evt) =>
    drawer.addEventListener(evt, hydrate, { once: true, passive: true })
  );

  // Safety net: capture phase runs before the theme's own click handler
  drawer.addEventListener('click', hydrate, { capture: true, once: true });
})();